:host 
  display: block
  width: fit-content
  margin: 0 auto

  @media screen and (min-width: 768px) 
    width: var(--width-tablet) !important

afs-link,
afs-link a 
  width: 100%

button
  width: 100%
  font-weight: 700
  font-family: var(--ff-pragati)
  letter-spacing: 0.09rem !important
  cursor: pointer

  @media screen and (min-width: 768px) 
    font-size: var(--tablet-font-size) !important

  &[data-disabled="true"]
    cursor: not-allowed
